// components/AboutUs.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function AboutUs() {
  return (
    <section id="about-us" className="py-5 bg-light">
      <Container>
        <h2 className="text-center mb-5">About Westron</h2>
        <Row className="align-items-center">
          <Col md={6} className="mb-4 mb-md-0">
            <video 
              src="https://cdn.dribbble.com/userupload/6060953/file/original-88cc20dd3c35b15139b56f516354c05d.mp4" 
              loop 
              autoPlay 
              muted 
              className="w-100 rounded"
            >
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col md={6}>
            <h3>Innovating the Digital Landscape</h3>
            <p>
              At Westron, we're passionate about creating cutting-edge digital solutions that empower businesses and delight users. With a team of skilled developers, designers, and strategists, we've been at the forefront of app and web development since our founding in 2010.
            </p>
            <p>
              Our mission is to transform ideas into powerful, user-friendly applications that drive growth and success for our clients. We combine technical expertise with creative problem-solving to deliver solutions that not only meet but exceed expectations.
            </p>
            <ul>
              <li>14+ years of industry experience</li>
              <li>100+ successful projects delivered</li>
              <li>Team of 50+ tech enthusiasts</li>
              <li>Cutting-edge technology stack</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default AboutUs;
